import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Analytics } from "@vercel/analytics/react";
import { AuthProvider } from "./contexts/AuthContext";
import { UIProvider } from "./contexts/UIContext";
import { NavigationProvider } from "./contexts/NavigationContext";
import { FinancialProvider } from "./contexts/FinancialContext";
import { ToastProvider } from "./contexts/ToastContext";
import { initPostHog } from "./lib/posthog";
import * as Sentry from "@sentry/react";
import App from "./App";
import "./styles/global.css";

// Sentry: solo en producción y si hay DSN configurado
if (import.meta.env.PROD && import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.MODE,
    tracesSampleRate: 0.1,
    // Privacidad: no enviar PII por default
    sendDefaultPii: false,
  });
}

// Inicializar PostHog antes del render — captura eventos anónimos desde el primer load
initPostHog();

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <AuthProvider>
      <UIProvider>
        <NavigationProvider>
          <FinancialProvider>
            <ToastProvider>
              <App />
              {/* Vercel Web Analytics — cookieless, solo se activa en prod de Vercel */}
              <Analytics />
            </ToastProvider>
          </FinancialProvider>
        </NavigationProvider>
      </UIProvider>
    </AuthProvider>
  </StrictMode>,
);

// ─── Registrar Service Worker (PWA) ─────────────────────────
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .then((reg) => {
        console.log("SW registrado:", reg.scope);
      })
      .catch((err) => {
        console.log("SW error:", err);
      });
  });
}
